import React from 'react';
import StarV2Icon from '../icons/StarV2Icon';

interface Props {
  action: 'favorited' | 'unfavorited';
}
const FavoritedProfileNotificationBanner: React.FC<Props> = ({ action }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 11,
      }}
    >
      <StarV2Icon width={16} height={15} cssStyle={{ marginRight: 6 }} />
      {action === 'favorited' ? <span>Profile Favorited!</span> : <span>Profile removed from Favorites</span>}
    </div>
  );
};

export default FavoritedProfileNotificationBanner;
